var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecifyFlowColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.001,
    height: 112.002,
    viewBox: "0 0 89.001 112.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28677",
    "data-name": "Group 28677",
    transform: "translate(-3208 -226.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_198",
    "data-name": "Union 198",
    d: "M4061.177,10669.5a44.471,44.471,0,0,1-27.177-41,32.26,32.26,0,0,1,1.939-10.259,70.3,70.3,0,0,1,4.931-10.884,161.628,161.628,0,0,1,14.665-21.6,300.307,300.307,0,0,1,21.2-24.029,2.5,2.5,0,0,1,3.466-.059,248.535,248.535,0,0,1,21.244,23.024,143.389,143.389,0,0,1,14.692,21.512,68.684,68.684,0,0,1,4.937,11.279A36.156,36.156,0,0,1,4123,10628.5a48.162,48.162,0,0,1-3.49,18.469,40.831,40.831,0,0,1-9.586,14.076,42.021,42.021,0,0,1-14.188,8.882A48.308,48.308,0,0,1,4078.5,10673,44.264,44.264,0,0,1,4061.177,10669.5Zm-1.741-80.617c-13.369,17.006-20.435,30.7-20.435,39.613a39.543,39.543,0,0,0,39.5,39.5c23.258,0,39.5-16.243,39.5-39.5,0-10.026-7.056-24.072-20.408-40.618a247.81,247.81,0,0,0-19.037-20.863C4075.169,10570.521,4067.26,10578.935,4059.436,10588.886ZM4054,10626a25,25,0,1,1,25,25A25.028,25.028,0,0,1,4054,10626Zm7.5,0,12.5,12.5,22.5-22.5-3.528-3.552L4074,10631.424l-8.976-8.949Z",
    transform: "translate(-826 -10334.998)",
    fill: "#024D82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M4079,10672c22.989-.232,39-16.407,39-39.5,0-10.025-7.055-24.071-20.41-40.618a247.588,247.588,0,0,0-18.59-20.429v-6.4a2.493,2.493,0,0,1,1.2.62,248.4,248.4,0,0,1,21.244,23.023,143.243,143.243,0,0,1,14.692,21.512,68.652,68.652,0,0,1,4.938,11.279A36.216,36.216,0,0,1,4123,10632.5a48.145,48.145,0,0,1-3.49,18.47,40.828,40.828,0,0,1-9.586,14.075,42.021,42.021,0,0,1-14.188,8.884A48.23,48.23,0,0,1,4079,10677Zm0-34.494,17.5-17.5-3.528-3.552L4079,10630.426V10605a25,25,0,0,1,0,50Z",
    transform: "translate(-826 -10339)",
    fill: "#024D82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecifyFlowColor);
export default __webpack_public_path__ + "static/media/SpecifyFlow-color.d6d901538dee034211d20643caa2e188.svg";
export { ForwardRef as ReactComponent };